import SvgColor from '../..//components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const navConfig = (role) => {
  const allConfig = [
    {
      title: 'dashboard',
      path: '/',
      icon: icon('ic_analytics'),
    },
    {
      title: 'My Stores',
      path: '/stores',
      icon: icon('ic_analytics'),
    },
    {
      title: 'sales',
      path: '/',
      icon: icon('ic_user'),
    },
    {
      title: 'Employees',
      path: '/employees',
      icon: icon('ic_user'),
    },
    {
      title: 'Products',
      path: '/products',
      icon: icon('ic_user'),
    },
    {
      title: 'Reporting',
      path: '/reporting',
      icon: icon('ic_analytics'),
    },
    {
      title: 'Login Reports',
      path: '/login-reports',
      icon: icon('ic_analytics'),
    },
    {
      title: 'Warehouses',
      path: '/warehouses',
      icon: icon('ic_analytics'),
    },
    {
      title: 'Transfers',
      path: '/transfers',
      icon: icon('ic_analytics'),
    }
  ];

  switch (role) {
    case 'Owner':
      return allConfig; // Owners can see all options including My Stores
    case 'Admin':
      return allConfig.filter((item) => !['dashboard', 'sales', 'My Stores', 'Warehouses', 'Transfers'].includes(item.title));
    case 'Manager':
      return allConfig.filter((item) => !['dashboard', 'My Stores', 'Warehouses', 'Transfers'].includes(item.title));
    case 'Sales Assistant':
      return allConfig.filter((item) => ['dashboard', 'Products', 'Reporting'].includes(item.title));
    default:
      return allConfig;
  }
} 

export default navConfig;
